// src/v3/account/facebook.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var FacebookIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "FacebookIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M6.84999 13.03H8.87999V21.0499C8.87999 21.4599 9.21999 21.7999 9.62999 21.7999H13.94C14.35 21.7999 14.69 21.4599 14.69 21.0499V13.03H16.78C17.19 13.03 17.53 12.69 17.53 12.28V9.34995C17.53 8.93995 17.19 8.59995 16.78 8.59995H14.37V7.77995C14.41 7.54995 14.98 6.93995 17.12 6.99995C17.32 6.99995 17.52 6.92995 17.66 6.78995C17.8 6.64995 17.88 6.45995 17.88 6.24995V2.94995C17.88 2.53995 17.54 2.19995 17.13 2.19995H15.32C11.77 2.19995 9.08999 4.38995 9.08999 7.29995V8.60995H6.85999C6.44999 8.60995 6.10999 8.94995 6.10999 9.35995V12.29C6.10999 12.7 6.44999 13.04 6.85999 13.04L6.84999 13.03ZM7.59999 10.1H9.82999C10.24 10.1 10.58 9.75995 10.58 9.34995V7.28995C10.58 5.23995 12.61 3.68995 15.31 3.68995H16.37V5.49995C15.02 5.56995 14.03 5.89995 13.43 6.49995C12.88 7.04995 12.86 7.62995 12.86 7.72995V9.34995C12.86 9.75995 13.2 10.1 13.61 10.1H16.02V11.53H13.93C13.52 11.53 13.18 11.87 13.18 12.28V20.2999H10.37V12.28C10.37 11.87 10.03 11.53 9.61999 11.53H7.58999V10.1H7.59999Z"
  }
) });

export {
  FacebookIcon
};
